import { Auth as Oauth } from "@pacificoseguros/tools";
import { env } from "../utils/env";

class Auth {
    static init = (): void => {
        Oauth.initialize({
            appId: env.string(process.env.REACT_APP_OAUTH_ID, "demo"),
            url: env.string(process.env.REACT_APP_OAUTH_URL, "demo"),
            storage: sessionStorage,
        });
    };
}

export default Auth;
